import leeCoreLex from 'bundles/epic/clients/leeCoreLex';

/**
 * The followup feature is used to restore the day 1 commitment screen and to update the CTA of the day 1 celebration modal.
 * @returns true if the daily goals followup feature is enabled
 */
export function isDailyGoalsFollowupEnabled() {
  return leeCoreLex.preview('enableDailyGoalsFollowup');
}

export function areDailyGoalsEnabled() {
  return leeCoreLex.preview('enableDailyGoals') || isDailyGoalsFollowupEnabled();
}

/**
 * Records an impression for the daily goals experiment at specific impression points.
 * Should be called only at the documented impression points:
 * - LIHP when continue learning modules are present
 * - My Learning tab
 * - In-course experience (daily task island)
 */
export function recordDailyGoalsImpression() {
  return leeCoreLex.get('enableDailyGoals') || leeCoreLex.get('enableDailyGoalsFollowup');
}

export function areMmmCelebrationScreensEnabled() {
  return leeCoreLex.preview('enableMmmCelebrationScreens') || isDailyGoalsFollowupEnabled();
}
